import { useMutation } from "@tanstack/react-query";
import { useSearchParams } from "react-router-dom";

import { ENDPOINTS } from "@/api/application-api";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { displayErrorToast, displayToast } from "@/utils/toast";
import { ToastType } from "@/enums";
import { jsonAuthHeaders } from "@/utils/headers";
import { useAuth } from "@/context/auth-context";

export interface SendVerificationEmailRequest {
  email: string;
}

export interface SendVerificationEmailResponse {
  success: boolean;
  message: string;
  email: string;
}

export const useSendVerificationEmail = () => {
  const auth = useAuth();
  const [searchParams] = useSearchParams();
  const state = searchParams.get("state");

  return useMutation(
    ["send-verification-email"],
    async (data: SendVerificationEmailRequest): Promise<SendVerificationEmailResponse> => {
      const response = await fetch(ENDPOINTS.auth.send_verification_email, {
        method: "POST",
        headers: jsonAuthHeaders(auth?.userToken ?? ""),
        body: JSON.stringify({
          ...data,
          state: state ?? undefined,
        }),
      });

      return handleResponse(response);
    },
    {
      onSuccess: data => {
        displayToast(data.message || "Verification code sent to your email", ToastType.success);
      },
      onError: error => {
        displayErrorToast(error || "Failed to send verification email");
      },
    },
  );
};
